import { render, staticRenderFns } from "./StudentScholarshipApprovalPage.vue?vue&type=template&id=2a7bbc27&scoped=true"
import script from "./StudentScholarshipApprovalPage.vue?vue&type=script&lang=js"
export * from "./StudentScholarshipApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./StudentScholarshipApprovalPage.vue?vue&type=style&index=0&id=2a7bbc27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7bbc27",
  null
  
)

export default component.exports